import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Update = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 28H16C9.383 28 4 22.617 4 16C4 12.508 5.467 9.265 8 7.007V9C8 9.552 8.448 10 9 10C9.552 10 10 9.552 10 9V5C10 4.448 9.552 4 9 4H5C4.448 4 4 4.448 4 5C4 5.552 4.448 6 5 6H6.152C3.515 8.602 2 12.173 2 16C2 23.72 8.28 30 16 30H17C17.552 30 18 29.552 18 29C18 28.448 17.552 28 17 28Z" />
		<path d="M27 26H25.848C28.485 23.398 30 19.827 30 16C30 8.28 23.72 2 16 2H15C14.448 2 14 2.448 14 3C14 3.552 14.448 4 15 4H16C22.617 4 28 9.383 28 16C28 19.492 26.533 22.735 24 24.993V23C24 22.448 23.552 22 23 22C22.448 22 22 22.448 22 23V27C22 27.552 22.448 28 23 28H27C27.552 28 28 27.552 28 27C28 26.448 27.552 26 27 26V26Z" />
		<path d="M22 11C22 10.448 21.552 10 21 10C20.661 10 20.362 10.169 20.181 10.427L13.972 19.296L11.799 16.401C11.617 16.158 11.327 16 11 16C10.448 16 10 16.448 10 17C10 17.225 10.075 17.432 10.201 17.599L13.202 21.6C13.384 21.842 13.674 22 14.001 22C14.34 22 14.639 21.831 14.82 21.573L21.82 11.573C21.934 11.411 22.001 11.213 22.001 11H22Z" />
	</svg>
);

export default Update;
